// @ts-nocheck
/**
 * DEATH STRANDING 2 - Animation Logic
 */

gsap.registerPlugin(ScrollTrigger);

const IS_MOBILE = window.innerWidth <= 768;

/** 加载动画期间锁定页面滚动（含 iOS 惯性滚动） */
let loaderSavedScrollY = 0;

const lockScrollForLoader = () => {
    loaderSavedScrollY = window.scrollY || document.documentElement.scrollTop;
    document.documentElement.style.overflow = "hidden";
    document.body.style.overflow = "hidden";
    document.body.style.position = "fixed";
    document.body.style.top = `-${loaderSavedScrollY}px`;
    document.body.style.left = "0";
    document.body.style.right = "0";
    document.body.style.width = "100%";
};

const unlockScrollAfterLoader = () => {
    document.documentElement.style.overflow = "";
    document.body.style.overflow = "";
    document.body.style.position = "";
    document.body.style.top = "";
    document.body.style.left = "";
    document.body.style.right = "";
    document.body.style.width = "";
    window.scrollTo(0, loaderSavedScrollY);
};

const initApp = () => {
    initLoader();
    initParallaxEffect();
    initSubscriptionForm();
    initParticles();
    initProductAnimations();
    initCollabAnimations();
    initCollabGallery();
    initVideoShowcase();
    initFeatureGrid();
    initYouTubeGallery();
    initShareJourney();
    initBlog();
    initBrandIntro();
    initFinale();
};

/**
 * 终章收场动画 (Finale) — 进入视口时触发入场 + 环境粒子飘动
 */
const initFinale = () => {
    const particleWrap = document.getElementById("finale_particles_wrap");
    if (!particleWrap) return;

    const vw = window.innerWidth;
    const vh = window.innerHeight;
    const particleCount = IS_MOBILE ? 20 : 55;

    // 生成环境粒子，随机散布并持续漂浮
    for (let i = 0; i < particleCount; i++) {
        const p = document.createElement("div");
        p.classList.add("f_particle");

        const size = Math.random() * 2.5 + 0.8;
        const hue = 18 + Math.random() * 28;
        const leftPct = Math.random() * 100;
        const topPct = Math.random() * 100;

        p.style.width = `${size}px`;
        p.style.height = `${size}px`;
        p.style.left = `${leftPct}%`;
        p.style.top = `${topPct}%`;
        p.style.background = `hsl(${hue}, 100%, 62%)`;
        p.style.boxShadow = `0 0 ${size * 3}px hsl(${hue}, 100%, 72%)`;
        p.style.opacity = "0";

        particleWrap.appendChild(p);

        // 粒子浮动循环动画（环境氛围）
        gsap.to(p, {
            x: `${(Math.random() - 0.5) * 80}px`,
            y: `${(Math.random() - 0.5) * 80}px`,
            duration: 4 + Math.random() * 6,
            repeat: -1,
            yoyo: true,
            ease: "sine.inOut",
            delay: Math.random() * 4
        });
    }

    const allParticles = particleWrap.querySelectorAll(".f_particle");

    // 进入视口时触发入场动画（只播一次）
    const entranceTL = gsap.timeline({
        scrollTrigger: {
            trigger: ".finale_section",
            start: "top 85%",
            toggleActions: "play none none none"
        }
    });

    // 顶部标签先浮现
    entranceTL.to(".finale_top_label", {
        opacity: 1,
        duration: 0.9,
        ease: "power2.out"
    })

    // 光环展开
    .to(".finale_ring", {
        scale: 1,
        opacity: 1,
        duration: 1.4,
        stagger: 0.25,
        ease: "back.out(1.2)"
    }, 0.2)

    // 粒子亮起
    .to(allParticles, {
        opacity: () => 0.3 + Math.random() * 0.5,
        duration: 1.2,
        stagger: { amount: 1.0, from: "random" },
        ease: "power1.out"
    }, 0.3)

    // Logo 主体从下方浮入
    .to(".finale_content", {
        opacity: 1,
        y: 0,
        duration: 1.0,
        ease: "power3.out"
    }, 0.5)

    // 底部文字
    .to(".finale_footer_text", {
        opacity: 1,
        duration: 0.8,
        ease: "power2.out"
    }, 1.0);

    // 鼠标视差：logo 跟随鼠标微移，光环反向漂移（仅桌面端）
    const section = document.querySelector(".finale_section");

    if (section && !IS_MOBILE) {
        section.addEventListener("mousemove", (e) => {
            const rx = (e.clientX / vw - 0.5) * 18;
            const ry = (e.clientY / vh - 0.5) * 18;

            gsap.to(".finale_content", {
                x: rx * 0.5,
                y: ry * 0.5,
                duration: 1.2,
                ease: "power2.out"
            });

            gsap.to(".finale_rings", {
                x: -rx * 0.7,
                y: -ry * 0.7,
                duration: 1.2,
                ease: "power2.out"
            });
        });
    }
};

/**
 * 品牌介绍模块动画
 */
const initBrandIntro = () => {
    if (!document.querySelector(".brand_intro_section")) return;

    const kojimaPanel = document.querySelector(".panel_kojima");
    const dnsysPanel = document.querySelector(".panel_dnsys");
    const divider = document.querySelector(".brand_divider");

    // 1. 左侧面板从左侧滑入
    gsap.fromTo(kojimaPanel, {
        x: "-8%",
        opacity: 0,
    }, {
        scrollTrigger: {
            trigger: ".brand_intro_section",
            start: "top 75%",
            toggleActions: "play none none reverse"
        },
        x: "0%",
        opacity: 1,
        duration: 1.2,
        ease: "power3.out"
    });

    // 2. 右侧面板从右侧滑入，稍作延迟形成错位感
    gsap.fromTo(dnsysPanel, {
        x: "8%",
        opacity: 0,
    }, {
        scrollTrigger: {
            trigger: ".brand_intro_section",
            start: "top 75%",
            toggleActions: "play none none reverse"
        },
        x: "0%",
        opacity: 1,
        duration: 1.2,
        delay: 0.15,
        ease: "power3.out"
    });

    // 3. 中间分割线从中心展开
    if (divider) {
        gsap.fromTo(divider, {
            scaleY: 0,
            opacity: 0,
        }, {
            scrollTrigger: {
                trigger: ".brand_intro_section",
                start: "top 70%",
                toggleActions: "play none none reverse"
            },
            scaleY: 1,
            opacity: 1,
            duration: 1,
            delay: 0.3,
            ease: "power2.out",
            transformOrigin: "center center"
        });
    }

    // 4. 面板内容（logo + 文字 + 线条）依次浮入
    gsap.fromTo(".panel_logo_block", {
        y: 30,
        opacity: 0,
    }, {
        scrollTrigger: {
            trigger: ".brand_intro_section",
            start: "top 65%",
            toggleActions: "play none none reverse"
        },
        y: 0,
        opacity: 1,
        duration: 0.9,
        stagger: 0.2,
        delay: 0.3,
        ease: "power2.out"
    });

    gsap.fromTo(".panel_desc", {
        y: 20,
        opacity: 0,
    }, {
        scrollTrigger: {
            trigger: ".brand_intro_section",
            start: "top 60%",
            toggleActions: "play none none reverse"
        },
        y: 0,
        opacity: 1,
        duration: 0.9,
        stagger: 0.2,
        delay: 0.5,
        ease: "power2.out"
    });

    gsap.fromTo(".panel_line_decor", {
        scaleX: 0,
        opacity: 0,
    }, {
        scrollTrigger: {
            trigger: ".brand_intro_section",
            start: "top 60%",
            toggleActions: "play none none reverse"
        },
        scaleX: 1,
        opacity: 1,
        duration: 0.8,
        stagger: 0.2,
        delay: 0.7,
        ease: "power2.out",
        transformOrigin: "left center"
    });
};

/**
 * Blog 模块动画
 */
const initBlog = () => {
    if (!document.querySelector(".blog_section")) return;

    // 1. 标题区块入场
    gsap.fromTo(".blog_header", {
        y: 40,
        opacity: 0,
    }, {
        scrollTrigger: {
            trigger: ".blog_section",
            start: "top 70%",
            toggleActions: "play none none reverse"
        },
        y: 0,
        opacity: 1,
        duration: 1,
        ease: "power2.out"
    });

    // 2. 博客卡片依次从下方浮入
    gsap.fromTo(".blog_card", {
        y: 70,
        opacity: 0,
    }, {
        scrollTrigger: {
            trigger: ".blog_grid",
            start: "top 80%",
            toggleActions: "play none none reverse"
        },
        y: 0,
        opacity: 1,
        duration: 0.9,
        stagger: 0.18,
        ease: "power3.out"
    });

    // 3. 卡片图片区域扫光入场效果
    gsap.fromTo(".card_image_wrapper", {
        clipPath: "inset(0 100% 0 0)",
    }, {
        scrollTrigger: {
            trigger: ".blog_grid",
            start: "top 80%",
            toggleActions: "play none none reverse"
        },
        clipPath: "inset(0 0% 0 0)",
        duration: 1,
        stagger: 0.18,
        ease: "power4.out"
    });

    // 4. 底部栏淡入
    gsap.fromTo(".blog_footer", {
        opacity: 0,
        y: 20,
    }, {
        scrollTrigger: {
            trigger: ".blog_footer",
            start: "top 90%",
            toggleActions: "play none none reverse"
        },
        opacity: 1,
        y: 0,
        duration: 0.8,
        ease: "power2.out"
    });
};

/**
 * Share Your Journey 动画
 */
const initShareJourney = () => {
    if (!document.querySelector(".share-journey-section")) return;

    // 1. 标题入场
    gsap.fromTo(".journey-header", {
        y: 30,
        opacity: 0,
    }, {
        scrollTrigger: {
            trigger: ".share-journey-section",
            start: "top 70%",
            toggleActions: "play none none reverse"
        },
        y: 0,
        opacity: 1,
        duration: 1,
        ease: "power2.out"
    });

    // 2. 步骤卡片依次入场
    gsap.fromTo(".step-card", {
        y: 50,
        opacity: 0,
    }, {
        scrollTrigger: {
            trigger: ".steps-container",
            start: "top 75%",
            toggleActions: "play none none reverse"
        },
        y: 0,
        opacity: 1,
        duration: 0.8,
        ease: "power2.out"
    });

    // 3. 奖品区域滑入
    gsap.fromTo(".prize-section", {
        x: -50,
        opacity: 0,
    }, {
        scrollTrigger: {
            trigger: ".prize-section",
            start: "top 85%",
            toggleActions: "play none none reverse"
        },
        x: 0,
        opacity: 1,
        duration: 1,
        ease: "power3.out",
        delay: 0.4 // 等步骤卡片出来后再显示
    });

    // 4. Hashtag 复制交互
    const hashtags = document.querySelectorAll('.hashtags span');
    hashtags.forEach(tag => {
        tag.addEventListener('click', () => {
            const textToCopy = tag.innerText;
            const originalText = textToCopy; // 保存原始文本

            // 复制到剪贴板
            navigator.clipboard.writeText(textToCopy).then(() => {
                // 反馈动画
                tag.classList.add('copied');
                tag.innerText = "COPIED";

                // 3秒后恢复
                setTimeout(() => {
                    tag.classList.remove('copied');
                    tag.innerText = originalText;
                }, 3000);
            }).catch(err => {
                console.error('Failed to copy: ', err);
            });
        });
    });
};

/**
 * YouTube 视频画廊逻辑
 */
const initYouTubeGallery = () => {
    const mainFrame = document.getElementById("main-video-frame");
    if (!mainFrame) return;

    const currentTitle = document.getElementById("current-video-title");
    const currentDuration = document.getElementById("current-video-duration");
    const thumbs = document.querySelectorAll(".video-thumb");
    const playerWrapper = document.querySelector(".main-player-wrapper");

    // 1. 点击切换逻辑
    thumbs.forEach(thumb => {
        thumb.addEventListener("click", () => {
            // 如果已经是激活状态，不操作
            if (thumb.classList.contains("active")) return;

            // 更新激活状态 UI
            thumbs.forEach(t => t.classList.remove("active"));
            thumb.classList.add("active");

            // 获取数据
            const videoId = thumb.getAttribute("data-id");
            const title = thumb.getAttribute("data-title");
            const duration = thumb.getAttribute("data-duration");

            // 动画过渡：先淡出播放器
            gsap.to(playerWrapper, {
                opacity: 0.5,
                scale: 0.98,
                duration: 0.3,
                ease: "power2.inOut",
                onComplete: () => {
                    // 更新内容
                    mainFrame.src = `https://www.youtube-nocookie.com/embed/${videoId}?enablejsapi=1&autoplay=1&referrerpolicy=strict-origin-when-cross-origin`; // 自动播放
                    currentTitle.innerText = title;
                    currentDuration.innerText = duration;

                    // 动画过渡：淡入播放器
                    gsap.to(playerWrapper, {
                        opacity: 1,
                        scale: 1,
                        duration: 0.5,
                        delay: 0.2, // 稍微等待 iframe 加载
                        ease: "power2.out"
                    });
                }
            });
        });
    });

    // 2. 入场动画
    const tl = gsap.timeline({
        scrollTrigger: {
            trigger: ".youtube-gallery-section",
            start: "top 70%",
            toggleActions: "play none none reverse"
        }
    });

    // 标题淡入
    tl.from(".gallery-header", {
        y: 30,
        opacity: 0,
        duration: 0.8,
        ease: "power2.out"
    })
    // 播放器框架展开
    .from(playerWrapper, {
        scaleX: 0,
        opacity: 0,
        duration: 0.8,
        ease: "expo.out"
    }, "-=0.4")
    // 缩略图依次上浮
    .from(thumbs, {
        y: 20,
        opacity: 0,
        stagger: 0.1,
        duration: 0.6,
        ease: "power2.out"
    }, "-=0.4");
};

/**
 * 功能网格动画 (Bento Grid)
 */
const initFeatureGrid = () => {
    if (!document.querySelector(".feature-grid-section")) return;

    // 1. 标题入场
    gsap.fromTo(".feature-header", {
        x: -50,
        opacity: 0,
    }, {
        scrollTrigger: {
            trigger: ".feature-grid-section",
            start: "top 70%",
            toggleActions: "play none none reverse",
        },
        opacity: 1,
        x: 0,
        duration: 1,
        ease: "power3.out"
    });

    // 2. 卡片 Stagger 入场 (仅透明度)
    gsap.from(".feature-card", {
        scrollTrigger: {
            trigger: ".feature-grid",
            start: "top 80%",
            toggleActions: "play none none reverse"
        },
        opacity: 0, // 仅保留透明度动画
        duration: 0.8, // 稍微放慢淡入速度，更优雅
        stagger: 0.1, 
        ease: "power2.out",
        clearProps: "opacity" // 动画结束后清除 opacity 样式
    });

    // 3. 数字增长动画
    const numbers = document.querySelectorAll(".big-number");
    numbers.forEach(num => {
        // 提取数字部分
        const rawText = num.innerText;
        const value = parseInt(rawText); 
        const suffix = rawText.replace(/[0-9]/g, ''); // 提取 %, lbs 等后缀

        // 创建代理对象用于动画
        const proxy = { val: 0 };

        gsap.to(proxy, {
            scrollTrigger: {
                trigger: num,
                start: "top 85%",
                once: true // 只执行一次
            },
            val: value,
            duration: 2,
            ease: "power2.out",
            onUpdate: function() {
                // 恢复后缀
                num.innerHTML = `${Math.floor(this.targets()[0].val)}<small>${suffix}</small>`;
            }
        });
    });

    // 4. 底部引语淡入
    // 使用 fromTo 替代 from，明确指定起始和结束状态，解决偶尔失效的问题
    gsap.fromTo(".feature-desc-section", 
        {
            opacity: 0,
            y: 30
        },
        {
            scrollTrigger: {
                trigger: ".feature-desc-section",
                start: "top 85%",
                toggleActions: "play none none reverse"
            },
            opacity: 1,
            y: 0,
            duration: 1.2,
            ease: "power2.out"
        }
    );
};

/**
 * 视频展示模块动画
 */
const initVideoShowcase = () => {
    const videoEl = document.querySelector(".showcase-video");
    if (!videoEl) return;

    // 视频懒加载：当视频区域进入视口时才加载并播放，避免页面加载时抢占带宽
    const loadVideo = () => {
        if (!videoEl || videoEl.querySelector("source")) return;

        const dataSrc = videoEl.getAttribute("data-src");
        if (!dataSrc) return;

        const source = document.createElement("source");
        source.src = dataSrc;
        source.type = "video/mp4";
        videoEl.appendChild(source);
        videoEl.load();
        videoEl.play().catch(() => {});
    };

    const videoObserver = new IntersectionObserver(
        (entries) => {
            if (entries[0].isIntersecting) {
                loadVideo();
                videoObserver.disconnect();
            }
        },
        { rootMargin: "200px" }
    );

    if (videoEl) videoObserver.observe(videoEl);

    // 移动端：跳过滚动动画，直接全屏展示视频，文案简单淡入
    if (IS_MOBILE) {
        gsap.set(".video-frame-decor", { opacity: 0 });
        gsap.to(".video-text-content", {
            scrollTrigger: {
                trigger: ".video-showcase-section",
                start: "top 60%",
                toggleActions: "play none none reverse"
            },
            opacity: 1,
            duration: 0.8,
            ease: "power2.out"
        });
        return;
    }

    // 1. 创建时间轴
    const tl = gsap.timeline({
        scrollTrigger: {
            trigger: ".video-showcase-section",
            start: "top top",
            end: "+=150%",
            pin: ".video-sticky-wrapper",
            scrub: 0.5,
            anticipatePin: 1
        }
    });

    // 2. 阶段一：视频从中心放大到全屏，同时淡出装饰框
    tl.to(".video-scale-container", {
        width: "100%",
        height: "100%",
        ease: "power4.out",
        duration: 0.8
    }, 0)
    .to(".video-frame-decor", {
        opacity: 0,
        duration: 0.3
    }, 0);

    // 3. 阶段二：文案浮现
    tl.to(".video-text-content", {
        opacity: 1,
        ease: "power2.out",
        duration: 0.8
    }, "-=0.2");
};

/**
 * 合作模块动画
 */
const initCollabAnimations = () => {
    if (!document.querySelector(".collab-section")) return;

    // 1. 标题入场
    gsap.from(".collab-subtitle", {
        scrollTrigger: {
            trigger: ".collab-header",
            start: "top 80%",
            toggleActions: "play none none reverse"
        },
        y: 20,
        opacity: 0,
        duration: 0.8,
        ease: "power2.out"
    });

    gsap.fromTo(".line-1", {
        x: -50,
        opacity: 0,
    }, {
        scrollTrigger: {
            trigger: ".collab-header",
            start: "top 80%",
            toggleActions: "play none none reverse"
        },
        x: 0,
        opacity: 1,
        duration: 1,
        delay: 0.2,
        ease: "power3.out"
    });

    gsap.fromTo(".line-2", {
        x: 50,
        opacity: 0,
    }, {
        scrollTrigger: {
            trigger: ".collab-header",
            start: "top 80%",
            toggleActions: "play none none reverse"
        },
        x: 0,
        opacity: 1,
        duration: 1,
        delay: 0.4,
        ease: "power3.out"
    });

    // 2. 文字块逐行入场
    gsap.fromTo(".collab-desc", {
        y: 30,
        opacity: 0,
    }, {
        scrollTrigger: {
            trigger: ".collab-text-block",
            start: "top 85%",
            toggleActions: "play none none reverse"
        },
        y: 0,
        opacity: 1,
        stagger: 0.3, // 每一段文字间隔 0.3秒
        duration: 1,
        ease: "power2.out"
    });

    // 3. Logo 淡入
    gsap.fromTo(".collab-logos", {
        scale: 0.9,
        opacity: 0,
    }, {
        scrollTrigger: {
            trigger: ".collab-logos",
            start: "top 90%",
            toggleActions: "play none none reverse"
        },
        scale: 1,
        opacity: 1,
        duration: 1.2,
        delay: 0.6,
        ease: "back.out(1.7)"
    });
};

/**
 * 产品模块动画
 */
const initProductAnimations = () => {
    if (!document.querySelector(".product-section")) return;

    // 1. 视觉元素入场
    const visualTl = gsap.timeline({
        scrollTrigger: {
            trigger: ".product-section",
            start: "top 60%",
            toggleActions: "play none none reverse"
        }
    });

    visualTl.from(".visual-circle-bg", {
        scale: 0,
        opacity: 0,
        duration: 1.5,
        ease: "power2.out"
    })
    .from(".main-product-img", {
        y: 50,
        opacity: 0,
        scale: 0.9,
        duration: 1,
        ease: "power3.out"
    }, "-=1")
    .to(".hotspot", {
        opacity: 1,
        duration: 0.5,
        stagger: 0.2
    }, "-=0.5");

    // 2. 信息面板入场
    const infoTl = gsap.timeline({
        scrollTrigger: {
            trigger: ".product-info-panel",
            start: "top 70%",
            toggleActions: "play none none reverse"
        }
    });

    infoTl.from(".brand-tag", { x: -20, opacity: 0, duration: 0.5 })
          .from(".product-title", { y: 20, opacity: 0, duration: 0.8 }, "-=0.3")
          .from(".price-block", { scale: 0.8, opacity: 0, duration: 0.5 }, "-=0.5")
          .from(".product-description", { opacity: 0, duration: 0.8 }, "-=0.3")
          .from(".specs-list li", { y: 20, opacity: 0, stagger: 0.1, duration: 0.5 }, "-=0.5")
          .from(".panel-footer", { y: 20, opacity: 0, duration: 0.5 }, "-=0.3");

    // 3. 鼠标跟随 3D Tilt 效果（仅桌面端）
    const visualContainer = document.querySelector(".product-visual");
    const productImg = document.querySelector(".main-product-img");

    if (!IS_MOBILE && visualContainer && productImg) {
        visualContainer.addEventListener("mousemove", (e) => {
            const rect = visualContainer.getBoundingClientRect();
            const x = e.clientX - rect.left; // 鼠标在容器内的 x
            const y = e.clientY - rect.top;  // 鼠标在容器内的 y
            
            // 计算中心点偏移 (-1 到 1)
            const xPct = (x / rect.width - 0.5) * 2;
            const yPct = (y / rect.height - 0.5) * 2;

            gsap.to(productImg, {
                rotationY: xPct * 10, // 左右倾斜
                rotationX: -yPct * 10, // 上下倾斜
                x: xPct * 20, // 轻微位移
                y: yPct * 20,
                duration: 0.5,
                ease: "power2.out"
            });
            
            // 背景圆圈反向移动，增强视差
            gsap.to(".visual-circle-bg", {
                x: -xPct * 30,
                y: -yPct * 30,
                duration: 1,
                ease: "power2.out"
            });
        });

        visualContainer.addEventListener("mouseleave", () => {
            gsap.to(productImg, {
                rotationY: 0,
                rotationX: 0,
                x: 0,
                y: 0,
                duration: 1,
                ease: "power2.out"
            });
            gsap.to(".visual-circle-bg", { x: 0, y: 0, duration: 1 });
        });
    }
};

/**
 * 背景粒子效果
 */
const initParticles = () => {
    const canvas = document.getElementById('particles-canvas');
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    let width = canvas.parentElement.offsetWidth;
    let height = canvas.parentElement.offsetHeight;
    let particles = [];
    
    // 粒子配置
    const particleConfig = {
        count: IS_MOBILE ? 30 : 80,
        baseSize: 2,         // 增大基础尺寸
        sizeVariation: 2,    // 增大尺寸变化
        speed: 0.6,
        drift: 0.3,
        color: '#f8d79b',    // 使用纯色，透明度由 alpha 控制
        maxLife: 300
    };

    // 调整画布大小
    const resize = () => {
        width = canvas.parentElement.offsetWidth;
        height = canvas.parentElement.offsetHeight;
        canvas.width = width;
        canvas.height = height;
    };
    
    window.addEventListener('resize', resize);
    resize();

    // 粒子类
    class Particle {
        constructor() {
            this.reset(true);
        }

        reset(initial = false) {
            this.x = Math.random() * width;
            this.y = initial ? Math.random() * height : height + 10;
            this.size = Math.random() * particleConfig.sizeVariation + particleConfig.baseSize;
            this.speedY = Math.random() * particleConfig.speed + 0.2;
            this.speedX = (Math.random() - 0.5) * particleConfig.drift;
            this.opacity = Math.random() * 0.6 + 0.2; // 提高透明度范围 (0.2 - 0.8)
            this.life = 0;
            this.maxLife = Math.random() * particleConfig.maxLife + 100;
        }

        update() {
            this.y -= this.speedY;
            this.x += this.speedX;
            this.life++;

            if (this.y < -10 || this.life > this.maxLife) {
                this.reset();
            }
        }

        draw() {
            ctx.beginPath();
            ctx.arc(this.x, this.y, this.size, 0, Math.PI * 2);
            ctx.fillStyle = particleConfig.color;
            ctx.globalAlpha = this.opacity;
            ctx.shadowBlur = 10; // 增加发光效果
            ctx.shadowColor = particleConfig.color;
            ctx.fill();
            ctx.shadowBlur = 0;
            ctx.globalAlpha = 1;
        }
    }

    // 初始化粒子
    for (let i = 0; i < particleConfig.count; i++) {
        particles.push(new Particle());
    }

    // 动画循环
    const animate = () => {
        ctx.clearRect(0, 0, width, height);
        
        particles.forEach(p => {
            p.update();
            p.draw();
        });

        // 连线效果（仅桌面端，移动端跳过以节省性能）
        if (!IS_MOBILE) {
            for (let i = 0; i < particles.length; i++) {
                for (let j = i + 1; j < particles.length; j++) {
                    const dx = particles[i].x - particles[j].x;
                    const dy = particles[i].y - particles[j].y;
                    const dist = Math.sqrt(dx * dx + dy * dy);

                    if (dist < 120) {
                        ctx.beginPath();
                        ctx.strokeStyle = `rgba(248, 215, 155, ${0.3 * (1 - dist / 120)})`;
                        ctx.lineWidth = 0.8;
                        ctx.moveTo(particles[i].x, particles[i].y);
                        ctx.lineTo(particles[j].x, particles[j].y);
                        ctx.stroke();
                    }
                }
            }
        }

        requestAnimationFrame(animate);
    };

    animate();
};

/**
 * 鼠标跟随视差效果
 */
const initParallaxEffect = () => {
    if (IS_MOBILE) return;

    const heroHud = document.querySelector(".hero_hud");
    if (!heroHud) return;

    window.addEventListener("mousemove", (e) => {
        const xPos = (e.clientX / window.innerWidth - 0.5) * 2;
        const yPos = (e.clientY / window.innerHeight - 0.5) * 2;

        gsap.to(".hud_product_label", {
            x: xPos * 6,
            y: yPos * 4,
            duration: 1.8,
            ease: "power2.out",
            overwrite: "auto"
        });

        gsap.to(".hud_frame_info", {
            x: xPos * -4,
            y: yPos * 3,
            duration: 1.8,
            ease: "power2.out",
            overwrite: "auto"
        });
    });
};

/**
 * 跳过加载动画时，直接进入首屏 Banner 状态
 */
const initHeroWithoutLoader = () => {
    if (!document.querySelector(".hero-section")) return;

    gsap.set(".logo-wrapper", { opacity: 1 });
    gsap.set(".scroll-hint", { opacity: 1 });
    initScrollAnimations();
    initHeroFrameAnimation();
};

/**
 * 
 * 初始化加载器逻辑
 */
const initLoader = () => {
    const appRoot = document.querySelector("#app");
    const loaderEl = document.querySelector("#loader");
    const skipLoader = appRoot && appRoot.dataset.skipLoader === "true";

    if (!loaderEl || skipLoader) {
        initHeroWithoutLoader();
        return;
    }

    lockScrollForLoader();

    const percentageText = document.querySelector("#loader_percentage");
    const trackFilled = document.querySelector("#walk_track_filled");
    const walkFigure = document.querySelector("#walk_figure");
    const trackContainer = document.querySelector("#walk_track_container");

    // --- Canvas 奔跑帧动画 ---
    const initRunnerCanvas = () => {
        const canvas = document.querySelector("#walk_canvas");
        if (!canvas) return;

        const ctx = canvas.getContext("2d");

        const CANVAS_W = 132;
        const CANVAS_H = 236;

        canvas.width = CANVAS_W;
        canvas.height = CANVAS_H;

        const frames = [new Image(), new Image()];

        frames[0].src = "https://cdn.shopify.com/s/files/1/0573/1545/9160/files/loading-1-yellow.png?v=1773650241";
        frames[1].src = "https://cdn.shopify.com/s/files/1/0573/1545/9160/files/loading-2-yellow.png?v=1773650249";

        let currentFrameIndex = 0;
        let lastSwitchTime = 0;
        const FRAME_INTERVAL = 160;
        let rafId = null;

        const drawFrame = (timestamp) => {
            if (timestamp - lastSwitchTime >= FRAME_INTERVAL) {
                const img = frames[currentFrameIndex];

                ctx.clearRect(0, 0, CANVAS_W, CANVAS_H);

                if (img.complete && img.naturalWidth > 0) {
                    ctx.drawImage(img, 0, 0, CANVAS_W, CANVAS_H);
                }

                currentFrameIndex = (currentFrameIndex + 1) % 2;
                lastSwitchTime = timestamp;
            }

            rafId = requestAnimationFrame(drawFrame);
        };

        const startAnimation = () => {
            if (rafId) cancelAnimationFrame(rafId);
            rafId = requestAnimationFrame(drawFrame);
        };

        if (frames[0].complete && frames[1].complete) {
            startAnimation();
        } else {
            let loadedCount = 0;

            const onLoad = () => {
                loadedCount++;
                if (loadedCount >= 1) startAnimation();
            };

            frames.forEach(img => {
                img.addEventListener("load", onLoad);
                img.addEventListener("error", onLoad);
            });
        }

        canvas._stopRunnerAnimation = () => {
            if (rafId) cancelAnimationFrame(rafId);
        };
    };

    initRunnerCanvas();

    // 初始渐显动画
    gsap.from(".loader_content", {
        opacity: 0,
        y: 10,
        duration: 1,
        ease: "power2.out"
    });

    // 进度管理对象
    const progress = { value: 0 };

    // 更新UI的函数
    const updateUI = () => {
        const val = Math.floor(progress.value);

        // 三位补零格式，如 "007"、"065"、"100"
        percentageText.innerText = String(val).padStart(3, "0");

        // 轨道填充宽度（全屏）
        trackFilled.style.width = `${progress.value}%`;

        // 人物水平位置：从屏幕左边走到右边，人物中心跟随填充右边缘
        const screenWidth = window.innerWidth;
        const figurePx = (progress.value / 100) * screenWidth;
        walkFigure.style.left = `${figurePx}px`;
    };

    // 完成加载后的离场逻辑
    const finishLoading = () => {
        const loaderOverlay = document.querySelector("#loader");
        const heroImageWrapper = document.querySelector(".hero-image-wrapper");

        gsap.set(heroImageWrapper, { opacity: 0 });

        const transitionTl = gsap.timeline();

        // 1. 进度轨道区域先快速淡出
        transitionTl.to(".walk_progress_section", {
            opacity: 0,
            duration: 0.2,
            ease: "power2.out"
        });

        // 2. loader 整体从下往上滑出屏幕（完全消失后执行所有后续入场）
        transitionTl.to(loaderOverlay, {
            yPercent: -100,
            duration: 0.55,
            ease: "power3.inOut",
            onComplete: () => {
                loaderOverlay.style.display = "none";
                unlockScrollAfterLoader();

                // 停止 canvas 帧动画
                const runnerCanvas = document.querySelector("#walk_canvas");
                if (runnerCanvas && runnerCanvas._stopRunnerAnimation) {
                    runnerCanvas._stopRunnerAnimation();
                }

                // logo 和 scroll-hint 淡入，淡入完成后再注册 ScrollTrigger
                // 这样 fromTo 捕获的初始值就是 opacity:1，scrub 回滚时能正确复原
                gsap.to(".logo-wrapper", {
                    opacity: 1,
                    duration: 0.8,
                    ease: "power2.out"
                });

                gsap.to(".scroll-hint", {
                    opacity: 1,
                    duration: 0.7,
                    ease: "power2.out",
                    delay: 0.15,
                    onComplete: initScrollAnimations
                });

                initHeroFrameAnimation();
            }
        });
    };

    // --- 真实加载进度逻辑 ---

    // 只追踪非懒加载图片（避免 loading="lazy" 的大图阻塞进度条）
    const images = Array.from(document.querySelectorAll('img:not([loading="lazy"])'));
    const totalImages = images.length;
    let loadedImagesCount = 0;
    
    // 更新目标进度的函数
    const updateProgressTarget = () => {
        loadedImagesCount++;
        // 计算当前基于资源的百分比
        const resourcePercent = (loadedImagesCount / totalImages) * 100;
        
        // 留一点空间给 window.onload
        const target = Math.min(resourcePercent, 95);
        
        // 只有当新计算的进度大于当前进度条的实际位置时，才去更新
        // 这样可以避免进度条倒退，同时如果“虚假动画”跑得比真实加载快，就保持虚假动画的进度
        if (target > progress.value) {
            gsap.to(progress, {
                value: target,
                duration: 0.5,
                overwrite: true, // 关键：接管之前的动画
                ease: "power1.out",
                onUpdate: updateUI
            });
        }
    };

    // 轻量起步动画：避免进度条长时间停在 0；真实进度由图片 load / window.load 驱动
    gsap.to(progress, {
        value: 22,
        duration: 2.5,
        ease: "power1.out",
        onUpdate: updateUI
    });

    // 绑定图片加载事件
    if (totalImages > 0) {
        images.forEach(img => {
            if (img.complete) {
                updateProgressTarget();
            } else {
                img.addEventListener("load", updateProgressTarget);
                img.addEventListener("error", updateProgressTarget);
            }
        });
    }

    // 页面资源加载完成即收尾，不再人为拉长等待时间
    const onWindowLoad = () => {
        gsap.to(progress, {
            value: 100,
            duration: 0.35,
            overwrite: true,
            ease: "power2.out",
            onUpdate: updateUI,
            onComplete: finishLoading
        });
    };

    if (document.readyState === "complete") {
        onWindowLoad();
    } else {
        window.addEventListener("load", onWindowLoad);
    }
};

/**
 * 初始化滚动动画
 */
const initScrollAnimations = () => {
    if (!document.querySelector(".hero-section")) return;

    const heroImageWrapper = document.querySelector(".hero-image-wrapper");
    const heroLogoWrapper = document.querySelector(".hero-logo-wrapper");

    if (heroLogoWrapper) heroLogoWrapper.style.transition = "none";

    gsap.set(".hero_black_overlay", { opacity: 0 });

    // 移动端：先展示背景和 logo，延迟 2s 后再淡入产品
    if (IS_MOBILE) {
        if (heroLogoWrapper) {
            gsap.set(heroLogoWrapper, { opacity: 1 });
        }

        gsap.to(heroImageWrapper, {
            opacity: 1,
            duration: 1.2,
            ease: "power2.out",
            delay: 2.0
        });

        if (document.querySelector(".content-section")) {
            gsap.to(".parallax-content", {
                scrollTrigger: {
                    trigger: ".content-section",
                    start: "top bottom",
                    end: "bottom top",
                    scrub: true
                },
                y: -50,
                ease: "none"
            });
        }

        return;
    }

    // 桌面端：logo 先快速消失（0% → 6%），canvas 再淡入（8% → 20%），两者不同时可见
    gsap.fromTo(".logo-wrapper",
        { opacity: 1 },
        {
            opacity: 0,
            ease: "power2.in",
            scrollTrigger: {
                trigger: ".hero-spacer",
                start: "top top",
                end: "6% top",
                scrub: 0.1
            }
        }
    );

    // canvas 在 logo 消失后才出现
    gsap.fromTo(heroImageWrapper,
        { opacity: 0 },
        {
            opacity: 1,
            ease: "none",
            scrollTrigger: {
                trigger: ".hero-spacer",
                start: "8% top",
                end: "20% top",
                scrub: 0.3
            }
        }
    );

    // 黑色遮罩：70% → 100% 淡入（过渡到第二屏）
    gsap.fromTo(".hero_black_overlay",
        { opacity: 0 },
        {
            opacity: 1,
            ease: "power1.inOut",
            scrollTrigger: {
                trigger: ".hero-spacer",
                start: "70% top",
                end: "bottom bottom",
                scrub: 0.1
            }
        }
    );

    // HUD corner 装饰：60% → 80% 淡出
    gsap.fromTo(".hud_corner",
        { opacity: 1 },
        {
            opacity: 0,
            ease: "none",
            scrollTrigger: {
                trigger: ".hero-spacer",
                start: "60% top",
                end: "80% top",
                scrub: 0.1
            }
        }
    );

    // scroll-hint：随 logo 同步消失（0% → 6%）
    gsap.fromTo(".scroll-hint",
        { opacity: 1 },
        {
            opacity: 0,
            ease: "power2.in",
            scrollTrigger: {
                trigger: ".hero-spacer",
                start: "top top",
                end: "6% top",
                scrub: 0.1
            }
        }
    );

    // Logo 在 spacer 滚出后显示
    if (heroLogoWrapper) {
        gsap.set(heroLogoWrapper, { opacity: 0, xPercent: -50 });

        ScrollTrigger.create({
            trigger: ".hero-spacer",
            start: "bottom bottom",
            onEnter: () => {
                gsap.to(heroLogoWrapper, {
                    opacity: 1,
                    duration: 0.9,
                    ease: "power2.out",
                    overwrite: true
                });
            },
            onLeaveBack: () => {
                gsap.to(heroLogoWrapper, {
                    opacity: 0,
                    duration: 0.5,
                    ease: "power2.in",
                    overwrite: true
                });
            }
        });
    }

    // 第二屏视差
    if (document.querySelector(".content-section")) {
        gsap.to(".parallax-content", {
            scrollTrigger: {
                trigger: ".content-section",
                start: "top bottom",
                end: "bottom top",
                scrub: true
            },
            y: -100,
            ease: "none"
        });
    }

    // 当内容区完全覆盖首屏后，隐藏 hero-section，防止底部滚动时首屏漏出
    const heroSection = document.querySelector(".hero-section");
    const contentSection = document.querySelector(".content-section");

    if (heroSection && contentSection && !IS_MOBILE) {
        ScrollTrigger.create({
            trigger: ".content-section",
            start: "top top",
            onEnter: () => {
                gsap.set(heroSection, { visibility: "hidden" });
            },
            onLeaveBack: () => {
                gsap.set(heroSection, { visibility: "visible" });
            }
        });
    }
};

/**
 * 首屏产品帧序列滚动动画
 */
const initHeroFrameAnimation = () => {
    const canvas = document.getElementById("hero_frame_canvas");
    if (!canvas) return;

    const ctx = canvas.getContext("2d");
    const TOTAL_FRAMES = 31;
    const FRAME_BASE_PATH = "https://cdn.shopify.com/s/files/1/0573/1545/9160/files/251121_DSver_renderings.529.";
    const frameImages = [];

    let currentFrameIndex = 0;
    let framesLoaded = 0;
    let isReady = false;

    // 调整 canvas 尺寸以匹配容器物理像素
    const resizeCanvas = () => {
        const dpr = window.devicePixelRatio || 1;
        const rect = canvas.getBoundingClientRect();

        canvas.width = rect.width * dpr;
        canvas.height = rect.height * dpr;
        ctx.scale(dpr, dpr);

        drawCurrentFrame();
    };

    // 将帧图像居中绘制到 canvas，保持宽高比，留有呼吸感
    const drawImageCentered = (img) => {
        if (!img || !img.complete || img.naturalWidth === 0) return;

        const displayW = canvas.width / (window.devicePixelRatio || 1);
        const displayH = canvas.height / (window.devicePixelRatio || 1);

        const imgRatio = img.naturalWidth / img.naturalHeight;
        const canvasRatio = displayW / displayH;

        const fillFactor = IS_MOBILE ? 0.88 : 0.72;

        let drawW, drawH;

        if (imgRatio > canvasRatio) {
            drawW = displayW * fillFactor;
            drawH = drawW / imgRatio;
        } else {
            drawH = displayH * fillFactor;
            drawW = drawH * imgRatio;
        }

        const drawX = (displayW - drawW) / 2;
        const drawY = (displayH - drawH) / 2;

        ctx.clearRect(0, 0, displayW, displayH);
        ctx.drawImage(img, drawX, drawY, drawW, drawH);
    };

    const drawCurrentFrame = () => {
        const img = frameImages[currentFrameIndex];

        if (img && img.complete && img.naturalWidth > 0) {
            drawImageCentered(img);
        } else {
            // 帧未加载完：绘制占位符
            const displayW = canvas.width / (window.devicePixelRatio || 1);
            const displayH = canvas.height / (window.devicePixelRatio || 1);
            ctx.clearRect(0, 0, displayW, displayH);
        }
    };

    // 更新 HUD 状态
    const updateHUD = (progress) => {
        const frameNum = Math.min(Math.round(progress * (TOTAL_FRAMES - 1)) + 1, TOTAL_FRAMES);
        const frameNumEl = document.getElementById("hud_frame_num");
        const frameBarFill = document.getElementById("hud_frame_bar_fill");
        const specsEl = document.getElementById("hud_specs");

        if (frameNumEl) {
            frameNumEl.textContent = String(frameNum).padStart(3, "0");
        }

        if (frameBarFill) {
            frameBarFill.style.width = `${progress * 100}%`;
        }

        if (specsEl) {
            const specsProgress = progress > 0.28 ? Math.min((progress - 0.28) / 0.18, 1) : 0;
            specsEl.style.opacity = specsProgress;
        }
    };

    // 初始化帧数组（占位）
    for (let i = 0; i < TOTAL_FRAMES; i++) {
        frameImages.push(null);
    }

    // 加载单帧的辅助函数
    const loadFrame = (index) => {
        return new Promise((resolve) => {
            const img = new Image();
            img.onload = () => {
                frameImages[index] = img;
                framesLoaded++;

                if (!isReady) {
                    isReady = true;
                    drawCurrentFrame();
                }

                resolve();
            };
            img.onerror = () => {
                framesLoaded++;
                resolve();
            };
            img.src = `${FRAME_BASE_PATH}${index + 1}.png`;
        });
    };

    // 顺序加载策略：先加载第 1 帧（立即显示），再顺序加载其余帧，避免带宽暴击
    const loadFramesSequentially = async () => {
        await loadFrame(0);

        for (let i = 1; i < TOTAL_FRAMES; i++) {
            await loadFrame(i);

            // 当前帧如果正好需要显示，立刻刷新
            if (i === currentFrameIndex) {
                drawCurrentFrame();
            }
        }
    };

    loadFramesSequentially();

    // 初始化 canvas 尺寸
    resizeCanvas();

    // ScrollTrigger：将滚动进度映射到帧索引
    ScrollTrigger.create({
        trigger: ".hero-spacer",
        start: "top top",
        end: "bottom bottom",
        scrub: true,
        onUpdate: (self) => {
            const progress = self.progress;
            const frameIndex = Math.min(
                Math.floor(progress * TOTAL_FRAMES),
                TOTAL_FRAMES - 1
            );

            if (frameIndex !== currentFrameIndex) {
                currentFrameIndex = frameIndex;
                drawCurrentFrame();
            }

            updateHUD(progress);
        }
    });

    // 响应窗口大小变化
    const onResize = () => {
        resizeCanvas();
    };

    window.addEventListener("resize", onResize, { passive: true });
};

/**
 * 订阅框交互逻辑
 */
const initSubscriptionForm = () => {
    const form = document.querySelector(".subscription-form");

    if (!form) return;

    const input = form.querySelector("input[type='email']");
    const btn = form.querySelector(".submit-btn");
    const btnText = form.querySelector(".btn-text");
    const btnDecor = form.querySelector(".btn-decor");

    const showSuccess = () => {
        btnText.innerText = "CONNECTED";
        input.value = "";
        input.placeholder = "ID REGISTERED";

        gsap.to(btn, {
            backgroundColor: "#00ffaa",
            color: "#000",
            borderColor: "#00ffaa",
            duration: 0.5
        });

        gsap.to(btnDecor, {
            backgroundColor: "#fff",
            scale: 1,
            opacity: 1,
            duration: 0.3
        });

        setTimeout(() => {
            input.disabled = false;
            btn.disabled = false;
            input.placeholder = "ENTER YOUR ID TO CONNECT";
            btnText.innerText = "SUBSCRIBE";

            gsap.to(btn, {
                backgroundColor: "rgba(248, 215, 155, 0.1)",
                color: "#f8d79b",
                borderColor: "rgba(248, 215, 155, 0.3)",
                duration: 0.5
            });

            gsap.to(btnDecor, {
                backgroundColor: "#00ffaa",
                opacity: 0.6,
                duration: 0.3
            });
        }, 3000);
    };

    const showError = () => {
        btnText.innerText = "ERROR — RETRY";
        input.disabled = false;
        btn.disabled = false;

        gsap.to(btn, {
            backgroundColor: "rgba(255, 80, 80, 0.2)",
            borderColor: "#ff5050",
            color: "#ff5050",
            duration: 0.3
        });

        setTimeout(() => {
            btnText.innerText = "SUBSCRIBE";

            gsap.to(btn, {
                backgroundColor: "rgba(248, 215, 155, 0.1)",
                color: "#f8d79b",
                borderColor: "rgba(248, 215, 155, 0.3)",
                duration: 0.5
            });
        }, 3000);
    };

    form.addEventListener("submit", async (e) => {
        e.preventDefault();

        input.disabled = true;
        btn.disabled = true;

        btnText.innerText = "CONNECTING...";

        gsap.to(btn, {
            backgroundColor: "rgba(248, 215, 155, 0.2)",
            borderColor: "#f8d79b",
            duration: 0.3
        });

        gsap.to(btnDecor, {
            opacity: 1,
            scale: 1.5,
            duration: 0.2,
            yoyo: true,
            repeat: 5
        });

        try {
            const formData = new FormData(form);
            const response = await fetch(form.action, {
                method: "POST",
                body: formData,
                headers: { "X-Requested-With": "XMLHttpRequest" }
            });

            if (response.ok) {
                showSuccess();
            } else {
                showError();
            }
        } catch (_err) {
            showError();
        }
    });
};

// 回到顶部按钮
const initBackToTop = () => {
    const backToTopBtn = document.getElementById("backToTopBtn");

    if (!backToTopBtn) return;

    let scrollTimer = null;

    const showBtn = () => {
        backToTopBtn.classList.add("is_visible");
    };

    const hideBtn = () => {
        backToTopBtn.classList.remove("is_visible");
    };

    window.addEventListener("scroll", () => {
        const scrollTop = window.scrollY || document.documentElement.scrollTop;

        // 正在滚动时立刻隐藏
        hideBtn();

        clearTimeout(scrollTimer);

        // 停止滚动 2s 后，若已滚动超过 300px 则显示
        if (scrollTop > 300) {
            scrollTimer = setTimeout(showBtn, 2000);
        }
    }, { passive: true });

    backToTopBtn.addEventListener("click", () => {
        hideBtn();
        window.scrollTo({ top: 0, behavior: "smooth" });
    });
};

/**
 * 吸顶 CTA 栏
 * 当 .subscription-wrapper 存在时：在其向上滚出视口后显示；
 * 否则（模板中订阅区已移除时）：以 .hero-spacer 为锚点，首屏滚动区离开视口后显示。
 * 滚动时压缩，停止后还原。
 */
const initStickySubBar = () => {
    const bar = document.getElementById("sticky_sub_bar");
    const triggerEl =
        document.querySelector(".subscription-wrapper") ||
        document.querySelector(".hero-spacer");

    if (!bar || !triggerEl) return;

    let isVisible = false;
    let scrollTimer = null;

    // 入场/离场动画进行中时，禁止切换 is_scrolling（防抖动）
    let isTransitioning = false;
    let transitionTimer = null;

    const TRANSITION_DURATION = 680; // 略大于 CSS transition 0.6s

    /* ── 1. IntersectionObserver：仅在订阅模块向上滚出时显示 ── */
    const observer = new IntersectionObserver(
        (entries) => {
            const entry = entries[0];

            // top < 0 → 元素已在视口上方（向上滚出）
            // top > 0 → 元素在视口下方（尚未到达，首屏或未滚到）
            const isAboveViewport = entry.boundingClientRect.top < 0;

            if (!entry.isIntersecting && isAboveViewport && !isVisible) {
                isVisible = true;
                isTransitioning = true;
                bar.classList.add("is_visible");
                bar.setAttribute("aria-hidden", "false");

                clearTimeout(transitionTimer);
                transitionTimer = setTimeout(() => {
                    isTransitioning = false;
                }, TRANSITION_DURATION);

            } else if ((entry.isIntersecting || !isAboveViewport) && isVisible) {
                isVisible = false;
                isTransitioning = true;
                bar.classList.remove("is_visible", "is_scrolling");
                bar.setAttribute("aria-hidden", "true");

                clearTimeout(scrollTimer);
                clearTimeout(transitionTimer);
                transitionTimer = setTimeout(() => {
                    isTransitioning = false;
                }, TRANSITION_DURATION);
            }
        },
        { threshold: 0 }
    );

    observer.observe(triggerEl);

    /* ── 2. 滚动时压缩，停止后弹性还原；动画期间跳过 ── */
    const onScroll = () => {
        if (!isVisible || isTransitioning) return;

        if (!bar.classList.contains("is_scrolling")) {
            bar.classList.add("is_scrolling");
        }

        clearTimeout(scrollTimer);

        scrollTimer = setTimeout(() => {
            bar.classList.remove("is_scrolling");
        }, 200);
    };

    window.addEventListener("scroll", onScroll, { passive: true });
};

/**
 * 合作模块图片轮播
 */
const initCollabGallery = () => {
    const gallery = document.querySelector(".collab-gallery");
    if (!gallery) return;

    const track = gallery.querySelector(".collab-gallery__track");
    const viewport = gallery.querySelector(".collab-gallery__viewport");
    const slides = Array.from(gallery.querySelectorAll(".collab-gallery__slide"));
    const prevBtn = gallery.querySelector(".collab-gallery__btn--prev");
    const nextBtn = gallery.querySelector(".collab-gallery__btn--next");
    const dotsContainer = gallery.querySelector(".collab-gallery__dots");

    if (!track || !viewport || slides.length === 0 || !dotsContainer) return;

    let currentIndex = 0;
    let touchStartX = 0;

    slides.forEach((_, index) => {
        const dot = document.createElement("button");
        dot.type = "button";
        dot.className = `collab-gallery__dot${index === 0 ? " active" : ""}`;
        dot.setAttribute("aria-label", `Go to slide ${index + 1}`);
        dot.addEventListener("click", () => goTo(index));
        dotsContainer.appendChild(dot);
    });

    const dots = Array.from(dotsContainer.querySelectorAll(".collab-gallery__dot"));

    const goTo = (index) => {
        currentIndex = (index + slides.length) % slides.length;
        track.style.transform = `translateX(-${currentIndex * 100}%)`;

        dots.forEach((dot, dotIndex) => {
            dot.classList.toggle("active", dotIndex === currentIndex);
        });
    };

    if (prevBtn) {
        prevBtn.addEventListener("click", () => goTo(currentIndex - 1));
    }

    if (nextBtn) {
        nextBtn.addEventListener("click", () => goTo(currentIndex + 1));
    }

    viewport.addEventListener("touchstart", (event) => {
        touchStartX = event.touches[0].clientX;
    }, { passive: true });

    viewport.addEventListener("touchend", (event) => {
        const touchEndX = event.changedTouches[0].clientX;
        const diff = touchStartX - touchEndX;

        if (Math.abs(diff) < 50) return;

        goTo(currentIndex + (diff > 0 ? 1 : -1));
    }, { passive: true });
};

// 启动应用
document.addEventListener("DOMContentLoaded", () => {
    initApp();
    initBackToTop();
    initStickySubBar();
});
